import React, { useEffect, useState } from 'react';

function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { 'x-auth-token': token } : {};
      const resp = await fetch('/api/admin/users', { headers });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to fetch users (endpoint may not be implemented)');
      }
      const data = await resp.json();
      // server returns { users, total, page, limit } — normalize to array
      setUsers(Array.isArray(data) ? data : (data.users || []));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchUsers(); }, []);

  const toggleAdmin = async (id, current) => {
    const confirmMsg = current ? 'Revoke admin from this user?' : 'Grant admin to this user?';
    if (!window.confirm(confirmMsg)) return;
    try {
      const token = localStorage.getItem('token');
      const resp = await fetch(`/api/admin/users/${id}/admin`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
        body: JSON.stringify({ admin: !current }),
      });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to update admin flag');
      }
      const data = await resp.json();
      // update local users state
      setUsers((prev) => prev.map(u => u._id === id ? { ...u, admin: data.admin } : u));
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  const exportCsv = () => {
    if (!users || users.length === 0) return;
    const rows = [['id','email','admin','createdAt'], ...users.map(u=>[u._id,u.email,!!u.admin,u.createdAt])];
    const csv = rows.map(r=>r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'users.csv'; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  };

  return (
    <div className="page admin-users-page">
      <header className="page-header">
        <span className="page-eyebrow">Admin</span>
        <h1>Users</h1>
        <p className="page-subtitle">List of registered users (requires server-side admin endpoint: GET /api/admin/users).</p>
      </header>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="admin-actions">
        <button className="btn btn-outline-secondary" onClick={fetchUsers} disabled={loading}>{loading ? 'Loading...' : 'Refresh'}</button>
        <button className="btn btn-primary" onClick={exportCsv} disabled={users.length===0}>Export CSV</button>
      </div>

      <section className="panel mt-3">
        {loading ? <p>Loading users…</p> : (
          users.length === 0 ? <div className="admin-empty">No users available or endpoint not implemented.</div> : (
            <table className="table">
              <thead>
                <tr><th>Email</th><th>Admin</th><th>Created</th><th/></tr>
              </thead>
              <tbody>
                {users.map(u => (
                  <tr key={u._id}>
                    <td>{u.email}</td>
                    <td>{u.admin ? 'Yes' : 'No'}</td>
                    <td>{new Date(u.createdAt).toLocaleString()}</td>
                    <td><button className="btn btn-sm btn-outline-primary" onClick={() => toggleAdmin(u._id, !!u.admin)}>{u.admin ? 'Revoke' : 'Grant'}</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}
      </section>
    </div>
  );
}

export default AdminUsers;
